<script setup lang="ts">
import { Toaster } from 'vue-sonner'
const session = useSession()
const actions = useStudioActions()
watch(() => session.value.data?.user.id, () => actions.close())
</script>
<template>
  <NuxtLayout><NuxtPage /></NuxtLayout>
  <ClientOnly><ActionHost v-if="session.data" /></ClientOnly>
  <Toaster theme="dark" />
</template>
